import { Component, OnDestroy, OnInit } from '@angular/core';
import { of, Subject, switchMap, takeUntil, map, catchError } from 'rxjs';
import { TabItem } from 'src/app/core/interfaces/tab-item.interface';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { PosHeaderActionsService } from 'src/app/core/services/pos-header-actions.service';
import { TabRoutesService } from 'src/app/core/services/tab-routes.service';
import { ShiftService } from 'src/app/core/services/shift.service';

@Component({
  selector: 'app-scafold-container',
  templateUrl: './scafold-container.component.html',
  styleUrl: './scafold-container.component.scss'
})
export class ScafoldContainerComponent implements OnInit, OnDestroy {
  items: TabItem[] = []
  showPosHeaderActions = false;
  currentDateTime = new Date();
  private clockTimer?: ReturnType<typeof setInterval>;

  private destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    if (this.clockTimer) {
      clearInterval(this.clockTimer);
    }

    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.startClock();

    this.tabRouteService.tabRotues$
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        this.items = res;
      });

    this.posHeaderActionsService.config$
      .pipe(takeUntil(this.destroy$))
      .pipe(
        switchMap((config) => {
          if (!config?.show) {
            return of(false);
          }

          return this.shiftService.getCurrentShift().pipe(
            map((response) => !!response?.data?.id),
            catchError(() => of(false))
          );
        })
      )
      .subscribe((hasOpenShift) => {
        this.showPosHeaderActions = hasOpenShift;
      });
  }

  onPosHeaderActionClick(actionId: string): void {
    this.posHeaderActionsService.emitClick(actionId);
  }

  get posHeaderDate(): string {
    const locale = this.localizationService.getCachedLanguage() === 'ar' ? 'ar-SA' : 'en-US';
    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(this.currentDateTime);
  }

  get posHeaderTime(): string {
    const locale = this.localizationService.getCachedLanguage() === 'ar' ? 'ar-SA' : 'en-US';
    return new Intl.DateTimeFormat(locale, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(this.currentDateTime);
  }

  private startClock(): void {
    this.currentDateTime = new Date();
    this.clockTimer = setInterval(() => {
      this.currentDateTime = new Date();
    }, 1000);
  }

  constructor(
    private tabRouteService: TabRoutesService,
    private posHeaderActionsService: PosHeaderActionsService,
    private localizationService: LocalizationService,
    private shiftService: ShiftService
  ) { }
}
